export default __webpack_public_path__ + "static/media/thumb_vivek.ee2e9d72.JPG";